import * as React from 'react';
import {Dropdown, Label, makeStyles, Option, tokens, useId,} from '@fluentui/react-components';
import {LocalLanguageRegular} from '@fluentui/react-icons';
import {Language} from "../../i18n";

const LANGUAGES: Record<Language, string> = {
    en: 'English',
    nl: 'Nederlands',
    fr: 'Français',
};

interface LanguagePickerProps {
    label: string
    value: Language;
    onChange: (value: Language) => void;
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
    },
    dropdown: {
        minWidth: '140px',
    },
});

export default function LanguagePicker(props: Readonly<LanguagePickerProps>) {
    const styles = useStyles();
    const dropdownId = useId("language-dropdown");

    return (
        <div className={styles.root}>
            <LocalLanguageRegular fontSize={20}/>
            <Label htmlFor={dropdownId}>{props.label}</Label>
            <Dropdown
                id={dropdownId}
                className={styles.dropdown}
                size="small"
                value={LANGUAGES[props.value]}
                selectedOptions={[props.value]}
                onOptionSelect={(_, data) => props.onChange(data.optionValue as Language)}
            >
                {Object.entries(LANGUAGES).map(([code, label]) => (
                    <Option key={code} value={code}>
                        {label}
                    </Option>
                ))}
            </Dropdown>
        </div>
    );
}